import axios from "../../utils/axios";

const apiUrl = process.env.REACT_APP_HS_API_URL;

// Backend returns `Ok()` with no body.
const addUserLoginLog = (userLoginLog) => axios.post<void>(`${apiUrl}/UserLoginLog`, userLoginLog);

const userLoginLogService = {
  addUserLoginLog,
}

export default userLoginLogService;